/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentAccessLogResponseDto } from '../../models/document-access-log-response-dto';

export interface DocumentAccessLogControllerGetDocumentAccessLogs$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Document ID
 */
  documentId: string;

/**
 * Number of logs to return (default: 50)
 */
  limit?: number;

/**
 * Start time filter (Unix timestamp)
 */
  startTime?: number;

/**
 * End time filter (Unix timestamp)
 */
  endTime?: number;
}

export function documentAccessLogControllerGetDocumentAccessLogs(http: HttpClient, rootUrl: string, params: DocumentAccessLogControllerGetDocumentAccessLogs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentAccessLogResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, documentAccessLogControllerGetDocumentAccessLogs.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('documentId', params.documentId, {});
    rb.query('limit', params.limit, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentAccessLogResponseDto>>;
    })
  );
}

documentAccessLogControllerGetDocumentAccessLogs.PATH = '/thalea-documents/access-logs/{tenant}/documents/{documentId}/logs';
